// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__adM80","buttons":"PendingPaymentAlert_buttons__3pksw"};